export default
    {
        path: '/404',
        name: '404',
        component: require('./index').default,
        hidden: true
    }
